import { render, staticRenderFns } from "./RegistrantBaseData.vue?vue&type=template&id=3150619c&"
import script from "./RegistrantBaseData.vue?vue&type=script&lang=js&"
export * from "./RegistrantBaseData.vue?vue&type=script&lang=js&"
import style0 from "./RegistrantBaseData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports